module.exports = __webpack_public_path__ + "static/media/Winner_illo.8c2d19cb.png";